// app/javascript/controllers/source_filter_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'type', 'item', 'count', 'group', 'section', 'countInGroup'];

  connect() {
    this.filter();
  }

  filter() {
    const q = this.hasInputTarget ? this.inputTarget.value.trim().toLowerCase() : '';
    const typ = this.hasTypeTarget ? this.typeTarget.value : 'all';
    let shown = 0;

    this.itemTargets.forEach((el) => {
      const hay = (el.dataset.filterKeywords || el.textContent || '').toLowerCase();
      const eTyp = el.dataset.filterType || '';
      const match = (!q || hay.includes(q)) && (typ === 'all' || eTyp === typ);

      el.classList.toggle('hidden', !match);
      el.toggleAttribute('aria-hidden', !match);
      el.toggleAttribute('inert', !match);
      if (match) shown += 1;
    });

    this.sectionTargets.forEach((sec) => {
      const visible = this.itemTargets.some(
        (item) => !item.classList.contains('hidden') && sec.contains(item)
      );
      sec.classList.toggle('hidden', !visible);
    });

    this.groupTargets.forEach((grp, i) => {
      const visibleItems = this.itemTargets.filter(
        (item) => !item.classList.contains('hidden') && grp.contains(item)
      );
      const countTarget = this.countInGroupTargets[i];
      grp.classList.toggle('hidden', visibleItems.length === 0);

      if (countTarget) countTarget.textContent = `(${visibleItems.length})`;
    });

    if (this.hasCountTarget) this.countTarget.textContent = shown;
  }
}
